








































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import DateInput2 from '@/components/inputs/DateInput2.vue'
import { ChainModule } from '@/store/modules/chain.module'
import { UserModule } from '@/store/modules/user.module'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import ModalV2 from '@/components/modals/ModalV2.vue'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import { required } from 'vuelidate/lib/validators'

@Component({
  props: {
    type: {
      type: String,
      default: 'chain'
    },
    task: {
      required: true,
      type: Object
    }
  },
  components: {
    InputValidator,
    ModalV2,
    InputV2,
    DateInput2
  }
})
export default class RescheduleTaskModal extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)

  isLoading: boolean = false

  date: string = ''
  note: string = ''

  validations (): any {
    return {
      date: { required },
      note: { required }
    }
  }

  get chain () {
    if (this.$props.type === 'user') {
      return this.user.chain
    }
    return this.$store.state.chain.chain
  }

  get user () {
    return this.$store.state.user.selectedUser
  }

  async submit () {
    this.$v.$touch()

    if (this.$v.$anyError) {
      return
    }

    try {
      this.isLoading = true
      const taskDate = new Date(this.$props.task.dueDate)
      const date = new Date(this.date)
      date.setHours(taskDate.getHours())
      date.setMinutes(taskDate.getMinutes())
      await this.chainModuleInstance.rescheduleTask({
        id: this.$props.task.id,
        date: date.getTime(),
        note: this.note
      })
      if (this.$props.type === 'user') {
        await this.chainModuleInstance.fetchUserAdminTasks(this.user.id)
      } else {
        await this.chainModuleInstance.fetchAdminTasks(this.chain.id)
      }
      this.$emit('close')
    } finally {
      this.isLoading = false
    }
  }
}
